import type {
  ReferencedBrand,
  ReferencedBrandCategory,
  ReferencedBrandPoi,
  ReferencedBrandsStats,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchReferencedBrandCategories = async (): Promise<ReferencedBrandCategory[]> => {
  const { data } = await gozokiApiWithAuth.get<ReferencedBrandCategory[]>(
    '/referenced-brand-categories',
  )
  return data
}

export const fetchReferencedBrands = async (): Promise<ReferencedBrand[]> => {
  const { data } = await gozokiApiWithAuth.get<ReferencedBrand[]>('/referenced-brands')
  return data
}

export const fetchReferencedBrandPois = async (): Promise<ReferencedBrandPoi[]> => {
  const { data } = await gozokiApiWithAuth.get<ReferencedBrandPoi[]>('/referenced-brand-pois')
  return data
}

export const fetchReferencedBrandsStats = async (): Promise<ReferencedBrandsStats> => {
  const { data } = await gozokiApiWithAuth.get<ReferencedBrandsStats>('/referenced-brands/stats')
  return data
}
